import React from 'react'
import { userRoles } from '../../data/mockData'

function RoleBadge({ role, size = 'md' }) {
  const getRoleConfig = (role) => {
    switch (role) {
      case userRoles.ADMIN:
        return { color: 'role-badge-admin', label: 'Admin' }
      case userRoles.Funder:
        return { color: 'role-badge-funder', label: 'Funder' }
      case userRoles.PROJECT_MANAGER:
        return { color: 'role-badge-pm', label: 'PM' }
      case userRoles.FINANCE:
        return { color: 'role-badge-finance', label: 'Finance' }
      case userRoles.CONSULTANT:
        return { color: 'role-badge-consultant', label: 'Consultant' }
      case userRoles.HR:
        return { color: 'bg-purple-100 text-purple-800 border border-purple-200', label: 'HR' }
      default:
        // A role ProTrack doesn't define — a product's own, like Region Admin or Country
        // Person. Show what it is called. Relabelling somebody's actual role as "User" throws
        // the only useful thing here away.
        return { color: 'bg-gray-100 text-gray-800 border border-gray-200', label: role || 'User' }
    }
  }

  const { color, label } = getRoleConfig(role)
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-xs px-2.5 py-1.5',
    lg: 'text-sm px-3 py-2'
  }

  return (
    <span className={`inline-flex items-center rounded-full font-medium ${color} ${sizeClasses[size]}`}>
      {label}
    </span>
  )
}

export default RoleBadge
